import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const akto = defineConnector({
  identifier: "akto",
  name: "Akto",
  tagLine: "API security testing",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://app.akto.io"),
  auth: headerAuth([
    { name: "X-API-KEY", value: { from: "secret", field: "apiKey" } },
  ]),
  steps: [
    {
      title: "Set up Akto",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API key under **Settings → Integrations → Automation → Akto API** in your Akto dashboard. Enter the dashboard URL and API key below. See [API setup](https://docs.akto.io/api-reference/api-reference).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://app.akto.io",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "For Akto Cloud, use https://app.akto.io. For self-hosted deployments, use the HTTPS URL of the deployed Akto dashboard; Akto’s API reference defines the API URL as the URL of your Akto dashboard.",
        },
        {
          kind: "input",
          label: "Akto API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Generate the key in the Akto dashboard under Settings → Integrations → Automation → Akto API.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://app.akto.io").trim().replace(/\/+$/, "") +
        "/api/getAllCollections",
      ...{
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: "{}",
      },
    }),
  },
});
